/**
 * @module builder
 */
import type { TieredPackages, TieredPackageTierId } from 'paintscout'

/** low → mid → high, in display order. */
export const TIER_ORDER: TieredPackageTierId[] = ['low', 'mid', 'high']

/**
 * Fixed positional labels for each tier slot. Used as the row headings in the setup
 * wizard and as the fallback display name when a tier's customer-facing `name` is blank.
 */
export const TIER_LABELS: Record<TieredPackageTierId, string> = {
  low: 'Good',
  mid: 'Better',
  high: 'Best'
}

/**
 * A blank tiered-packages config used to seed the setup wizard. The middle tier
 * is the base (current estimate) by default, with the other two priced ±10%.
 * Tier `name`s start blank so the Package Name input shows its placeholder and the
 * UI falls back to the positional label (TIER_LABELS).
 */
export function getDefaultTieredPackages(): TieredPackages {
  const tier = (level: TieredPackages['tiers']['low']['level'], value: number) => ({
    level,
    name: '',
    tagline: '',
    features: [] as string[],
    contentType: 'features' as const,
    description: '',
    adjustment: { type: 'percentage' as const, value }
  })

  return {
    enabled: false,
    baseTierId: 'mid',
    selectedTierId: 'mid',
    recommendedTierId: 'mid',
    priceMode: 'percentage',
    priceDisplay: 'total',
    tiers: {
      low: tier('Basic', -10),
      mid: tier('Standard', 0),
      high: tier('Premium', 10)
    }
  }
}
